import Token from '@/utils/Token';

export default {
    parse(data) {
        ['ativo'].forEach(item => {
            data[item] = parseInt(data[item]);
        });

        return data;
    },

    get(id, params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/pendencia/${id}${params}`, Token.getHeader());
    },
    list(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/pendencia/list${params}`, Token.getHeader());
    },
    download(params="") {
        if(params) params = `?${params}`;
        const headers = Token.getHeader();
        headers.responseType = 'blob';

        return axios.get(`/api/pendencia/download${params}`, headers);
    },
    totalPendente(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/pendencia/totalPendente${params}`, Token.getHeader());
    },

    listContrato(contrato_id, params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/pendencia/listContrato/${contrato_id}${params}`, Token.getHeader());
    },

    resolvido(id,params) {
        return axios.post(`/api/pendencia/resolvido/${id}`, params, Token.getHeader());
    },

    qtdPendentes(contrato_id,params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/pendencia/qtdPendentes/${contrato_id}${params}`, Token.getHeader());
    },

    qtdTotal(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/pendencia/qtdTotal${params}`, Token.getHeader());
    },

    option(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/pendencia/option${params}`, Token.getHeader());
    },

    create(params) {
        return axios.post(`/api/pendencia`, params, Token.getHeader());
    },
    update(id,params) {
        return axios.post(`/api/pendencia/${id}`, params, Token.getHeader());
    },
    delete(id) {
        return axios.delete(`/api/pendencia/${id}`, Token.getHeader());
    },
}
